export const DIGITAL_MEMORY_LOG_CONSTANTS = {
  // Table configuration
  TABLE: {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZES: [10, 20, 30],
    TABLE_HEIGHT: 'calc(100vh - 272px)',
    SEARCH_DEBOUNCE_TIME: 300,
  },

  // Navigation
  ROUTES: {
    OVERVIEW: '/overview',
    CREATE_PREFIX: '/overview/ship-',
    CREATE_SUFFIX: '/create-digital-memory-log-',
    EDIT_PREFIX: '/overview/ship-',
    EDIT_SUFFIX: '/edit-digital-memory-log-',
    PREVIEW_PREFIX: '/preview-',
  },

  // URL patterns
  URL_PATTERNS: {
    SHIP_NAME_REGEX: /[^a-z0-9\-]/g,
    DIGITAL_MEMORY_NAME_REGEX: /[^a-z0-9\s-]/g,
  },

  // Messages
  MESSAGES: {
    SUCCESS: {
      LINK_COPIED: 'Preview link copied to clipboard!',
    },
    ERROR: {
      COPY_FAILED: 'Failed to copy link',
    },
    EXPIRED_TOOLTIP: 'This digital memory log has expired',
  },

  // CSS Classes
  CSS_CLASSES: {
    COLUMN_NAME: 'text-capitalize column-name text-inline',
    TEXT_INLINE: 'text-capitalize text-inline',
    ACTION_STICKY: 'text-capitalize action-sticky text-inline dropdown-visible',
  },

  SESSION_STORAGE: {
    PREVIEW_RETURN_URL: 'preview_return_url',
    PREVIEW_IGNORE_BACK_ONCE: 'preview_ignore_back_once',
    PREVIEW_IN_FILE_DETAIL: 'preview_in_file_detail',
    PREVIEW_BACK_INTERCEPT: 'preview_back_intercept',
  },

  // Default values
  DEFAULTS: {
    SHIP_NAME: 'ship',
    DIGITAL_MEMORY_NAME: 'digital-memory',
    EXPIRY_YEARS: 1,
  },
};
